import { List } from 'antd';
import styled, { useTheme } from 'styled-components';
import { TestItemSummary } from '../../../2_domain/test/test';
import { toIDPrice } from '../../../lib/util/numberFormatter';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXList from '../../core/components/list/lx_list';
import { LXbody, LXCaption } from '../../core/texts/lxText';
// import { LXh4 } from '../../core/texts/lxText';
interface TestItemListProps {
  testItems: TestItemSummary[];
}
const HeaderPadding = styled.div`
  padding: 0px 10px;
`;

const ItemPadding = styled.div`
  padding: 12px 10px;
`;

const TestItemList: React.FC<TestItemListProps> = (props) => {
  const theme = useTheme();

  const header = (
    <HeaderPadding>
      <Row alignItems="center">
        <LXCaption width={'40px'}>{theme.texts.no}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'80px'}>{theme.texts.testCode}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'456px'}>{theme.texts.testItem}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'144px'}>{theme.texts.price}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'96px'}>{theme.texts.requiredDay}</LXCaption>
      </Row>
    </HeaderPadding>
  );

  const listItemBuilder = (testItem: TestItemSummary, idx: number) => {
    return (
      <List.Item>
        <ItemPadding>
          <Row>
            <LXbody width={'40px'}>{idx + 1}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'80px'}>{testItem.serial}</LXbody>
            <SizedBox width={16}></SizedBox>
            <Column>
              <LXbody width={'456px'}>{testItem.name}</LXbody>
              <SizedBox height={4}></SizedBox>
              <LXbody color={theme.colors.caption} width={'456px'}>
                {testItem.testCategory.label}
              </LXbody>
            </Column>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'144px'}>{toIDPrice(testItem.amount, true)}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'96px'}>{`${testItem.requiredDays ?? 0} Day${
              testItem.requiredDays === 1 ? '' : 's'
            }`}</LXbody>
          </Row>
        </ItemPadding>
      </List.Item>
    );
  };

  return (
    <Column>
      {/* <LXh4>{theme.texts.testItem}</LXh4> */}
      <SizedBox height={16}></SizedBox>
      <LXList<TestItemSummary>
        datas={props.testItems}
        header={header}
        itemBuilder={listItemBuilder}
        minHeight={undefined}
      ></LXList>
    </Column>
  );
};

export default TestItemList;
